import { useMemo } from 'react';
import type { ChatroomsListFilter } from '../../types';
import type { ChatroomSidebarFiltersFormValues } from '../chatroom-sidebar-filters';

export const useGetInitialValues = (filter: ChatroomsListFilter) =>
  useMemo(
    (): Partial<ChatroomSidebarFiltersFormValues> => ({
      search: filter.search,
      type: filter.type,
    }),
    [filter],
  );
